import { MessageCircle } from "lucide-react";
import { whatsappLink, openWhatsApp } from "@/lib/site";

export default function WhatsAppFloat() {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => {
        // Robust fallback in case target=_blank is blocked (e.g. iframed preview)
        e.preventDefault();
        openWhatsApp();
      }}
      data-testid="floating-whatsapp-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 group cursor-pointer"
    >
      <span className="pointer-events-none absolute inset-0 rounded-full bg-[#006241] opacity-40 blur-xl group-hover:opacity-60 transition-opacity" />
      <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#006241] hover:bg-[#0a8a5e] pulse-glow transition-all duration-300 group-hover:scale-105">
        <MessageCircle className="h-6 w-6 md:h-7 md:w-7 text-white" />
      </span>
    </a>
  );
}
